// AssetsComingSoon Component
// Work-in-progress placeholder for the Assets section (no Discord link)

export function AssetsComingSoon() {
  return (
    <div className="assets-panel">
      <h1 className="assets-title">Assets</h1>
      <p className="assets-subtitle">
        Our asset library is coming soon. Check back later for downloads, templates, and more.
      </p>
    </div>
  );
}
